export const Routes = {
  customers: '/',
  admins: '/admins',
  login: '/login',
  logout: '/logout',
  customer: '/customer/:id',
};
